import VoucherList from "../../components/VoucherList/VoucherList";

const VoucherListPage = () => {
  return <VoucherList />;
};

export default VoucherListPage;
